import { createTypedHooks } from 'easy-peasy';

import { StoreModel } from '@digital/ui';
import counter, { CounterModel } from './counter';
import abaPendencia, { AbaPendenciaModel } from './abaPendencias';

interface AppStoreModel {
  counter: CounterModel;
  abaPendencia: AbaPendenciaModel;
}

const models: AppStoreModel = {
  counter,
  abaPendencia,
};

const { useActions, useStore } = createTypedHooks<AppStoreModel & StoreModel>();

export { useActions, useStore };

export default models;
